import { useSelector } from 'hooks/utils';
import { selectLicenseOwnerFullName } from 'store/account/subscription';

export function useLicenseOwnerFullName() {
	return useSelector(state => selectLicenseOwnerFullName(state.account.subscription));
}
